/**
 * 落とした直後の待ち時間（drop.cooldownMs）のあいだのタップを、1回分だけ取っておく。
 *
 * 待ちの最中のタップを捨てると「押したのに落ちない」になり、テンポよく落としたい人ほど
 * 取りこぼす。2回以上押しても取っておくのは最後の1回（の位置）だけにして、
 * 連打で何個も続けて落ちないようにする。
 */
export class PendingDrop {
  private x: number | null = null;

  get pending(): boolean {
    return this.x !== null;
  }

  /** 待ちのあいだのタップを取っておく（位置は最後のタップで上書き）。 */
  queue(x: number): void {
    this.x = x;
  }

  /**
   * 待ちが明けていれば、取っておいた位置を返して空にする。
   * まだ待ちのあいだ、または何も取っていなければ null。
   */
  take(now: number, lastDropAt: number, cooldownMs: number): number | null {
    if (this.x === null) return null;
    if (now - lastDropAt < cooldownMs) return null;
    const x = this.x;
    this.x = null;
    return x;
  }

  clear(): void {
    this.x = null;
  }
}
